import React from "react";
import { Trash2 } from "lucide-react";

/**
 * Glow Journal — grid of saved AR-mirror snapshots for the current routine.
 *
 * Extracted out of Routine.jsx so the parent route stays under 600 lines
 * and this purely-presentational chunk can be re-used elsewhere later
 * (e.g. an "all my snapshots" page).
 */
const RoutineGlowJournal = ({ snapshots, onDelete }) => {
  if (!snapshots?.length) return null;
  return (
    <div
      className="mt-12 bg-white border border-[#EADDD7] rounded-3xl p-6 sm:p-8 soft-shadow"
      data-testid="routine-snapshots-section"
    >
      <div className="flex items-center justify-between mb-6 flex-wrap gap-2">
        <div>
          <span className="inline-block text-xs uppercase tracking-[0.25em] text-[#9B6A6C] mb-1">
            Your glow journal
          </span>
          <h3 className="text-2xl font-light text-[#2C2123]">
            Moments from the mirror
          </h3>
        </div>
        <span className="text-sm text-[#8A7D82]">{snapshots.length} saved</span>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3">
        {snapshots.map((s) => (
          <div
            key={s.id}
            className="group relative aspect-[3/4] rounded-2xl overflow-hidden bg-[#F5EFEB] border border-[#EADDD7]"
            data-testid={`routine-snapshot-${s.id}`}
          >
            <img
              src={`data:${s.mime_type};base64,${s.image_base64}`}
              alt={s.step_title}
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-90" />
            <div className="absolute bottom-2 left-2 right-2 flex items-end justify-between">
              <div className="text-white text-[11px] leading-tight pr-2">
                <div className="font-medium line-clamp-1">{s.step_title}</div>
                <div className="text-white/70 text-[10px]">
                  Step {s.step_idx + 1}
                </div>
              </div>
              <button
                onClick={() => onDelete(s.id)}
                className="h-7 w-7 rounded-full bg-white/15 backdrop-blur-md border border-white/20 flex items-center justify-center text-white hover:bg-white/30 transition-all opacity-0 group-hover:opacity-100"
                data-testid={`routine-snapshot-delete-${s.id}`}
                aria-label="Remove moment"
              >
                <Trash2 className="h-3.5 w-3.5" />
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RoutineGlowJournal;
